import * as Yup from 'yup';

import {
  DOCUMENT_SECTIONS_IDS,
  shouldDebSecondPageSectionRender,
} from 'components/DEBForm/Utils/DebFormSectionUtil';
import {
  DEB_DOCUMENTS_FIELDS,
  DEB_EXPERTS_DOCUMENTS_FIELDS,
} from 'components/DEBForm/Utils/DocumentsFields';

import {
  BRANCH_TYPE,
  EIV_STATUS,
  EIV_STATUS_ALLOW_RENDER,
  FORM_CONSTANTS,
  INSTALLER_ENTRIES,
  TENANT_ID,
  VALIDATION_CONSTANTS,
} from 'global/constants';
import { evaluateCondition } from 'global/fieldValidationFunction';
import { FIRST_QUALIFICATIONS, SECOND_QUALIFICATIONS } from 'global/qualifications';

import {
  isRegisteredBranchGuest,
  isRegisteredBranchMain,
  isRegisteredInstallerOnlyHilfsbetrieb,
} from 'utils/InstallerUtils';
import { getTenantId } from 'utils/tenantUtil';

const mainGasPossibilities = [
  INSTALLER_ENTRIES.MAIN_GAS_ONLY,
  INSTALLER_ENTRIES.MAIN_BOTH,
  INSTALLER_ENTRIES.GUEST_ENERGY_MAIN_GAS,
];

const expertTriggerIdsTenant = {
  [TENANT_ID.AVA]: [1],
  [TENANT_ID.EDI]: [1],
  [TENANT_ID.SHNG]: [1],
  [TENANT_ID.BAG]: [1, 2, 3],
  [TENANT_ID.LVN]: [],
  [TENANT_ID.MTN]: [1], // TODO: might need updates, look at the expertDocuments that use company information to render
};

export const calcExpertTriggers = (
  valuesFirstPage,
  initialValuesFirstPage,
  installerStatusSummary,
  documentsTrigger
) => {
  const expertTriggers = {};
  valuesFirstPage.experts.forEach((expert) => {
    const triggers = [];
    const gasStatusesRender = [EIV_STATUS.ACTIVE, EIV_STATUS.IN_PROGRESS];
    const energyStatusesRender = [EIV_STATUS.ACTIVE, EIV_STATUS.IN_PROGRESS];
    const guestEnergy = isRegisteredBranchGuest(installerStatusSummary, BRANCH_TYPE.ENERGY);
    const guestGas = isRegisteredBranchGuest(installerStatusSummary, BRANCH_TYPE.GAS);
    if (expert.firstQualificationEnergy) {
      triggers.push(FIRST_QUALIFICATIONS[expert.firstQualificationEnergy].triggerID);
    }
    if (expert.firstQualificationGas) {
      triggers.push(FIRST_QUALIFICATIONS[expert.firstQualificationGas].triggerID);
    }
    if (expert.secondQualificationEnergy) {
      triggers.push(SECOND_QUALIFICATIONS[expert.secondQualificationEnergy].triggerID);
    }
    if (expert.secondQualificationGas) {
      triggers.push(SECOND_QUALIFICATIONS[expert.secondQualificationGas].triggerID);
    }
    if (expert.isExpertOwner) {
      triggers.push(40);
    }

    // if (documentsTrigger.includes(12)) {
    //   if (gasStatusesRender.includes(expert.statusGas)) {
    //     if (!guestGas) {
    //       triggers.push(12);
    //     } else {
    //       const oldExpert = initialValuesFirstPage.experts.find(
    //         (initialExpert) => initialExpert.id === expert.id
    //       );
    //       if (
    //         expert.statusGas === EIV_STATUS.NEW ||
    //         expert.expertGasValidityDate !== oldExpert.expertGasValidityDate
    //       ) {
    //         triggers.push(12);
    //       }
    //     }
    //   }
    // }
    if (expert.isExpertExtendedGas) {
      triggers.push(12);
    }
    if (expert.isExpertExtendedEnergy) {
      triggers.push(11);
    }
    // if (documentsTrigger.includes(11)) {
    //   if (energyStatusesRender.includes(expert.statusEnergy)) {
    //     if (!guestEnergy) {
    //       triggers.push(11);
    //     } else {
    //       const oldExpert = initialValuesFirstPage.experts.find(
    //         (initialExpert) => initialExpert.id === expert.id
    //       );
    //       if (
    //         expert.statusEnergy === EIV_STATUS.NEW ||
    //         expert.expertEnergyValidityDate !== oldExpert.expertEnergyValidityDate
    //       ) {
    //         triggers.push(11);
    //       }
    //     }
    //   }
    // }
    if (expert.statusGas === EIV_STATUS.NEW) {
      documentsTrigger.push(10);
      triggers.push(10);
    }
    if (expert.statusEnergy === EIV_STATUS.NEW) {
      triggers.push(9);
      documentsTrigger.push(9);
    }
    if (expert.statusGas === EIV_STATUS.DELETED) {
      triggers.push(23);
    }
    if (expert.statusEnergy === EIV_STATUS.DELETED) {
      triggers.push(24);
    }

    expertTriggers[expert.id] = Array.from(new Set(triggers));
  });
  return [expertTriggers, Array.from(new Set(documentsTrigger))];
};

export const calcInstallerTriggersIds = (changedValues) => {
  const documentTriggerIds = Object.keys(changedValues).reduce((acc, key) => {
    const sectionIds = DOCUMENT_SECTIONS_IDS.filter((section) => section.fields.includes(key)).map(
      (section) => section.id
    );
    return acc.concat(sectionIds);
  }, []);
  if (changedValues.experts) {
    changedValues.experts.forEach((expert) => {
      if (expert.isExpertExtendedEnergy) {
        documentTriggerIds.push(11);
      }
      if (expert.isExpertExtendedGas) {
        documentTriggerIds.push(12);
      }
    });
  }
  return Array.from(new Set(documentTriggerIds));
};

export const updateExpertTriggersForMainGas = (
  valuesFirstPage,
  installerStatusSummary,
  documentTriggerIds,
  expertTriggers
) => {
  if (
    mainGasPossibilities.includes(installerStatusSummary.installerEntry) &&
    expertTriggerIdsTenant[getTenantId()].some((id) => documentTriggerIds.includes(id))
  ) {
    valuesFirstPage.experts.forEach((expert) => {
      if (EIV_STATUS_ALLOW_RENDER.includes(expert.statusGas)) {
        expertTriggers[expert.id] = [...expertTriggers[expert.id], 1];
      }
    });
  }
};

export const createInitialValues = (
  changedValues,
  documentTriggerIds,
  expertTriggers,
  installer
) => ({
  experts: changedValues.experts,
  documentsTrigger: documentTriggerIds,
  expertTrigger: expertTriggers,
  isAddressPublic: installer.zuAdressveroeff === 'Ja',
  canSendMail: installer.zuInfoversand === 'Ja',
  changes: '',
});

export const createValidationSchema = (
  valuesFirstPage,
  initialValues,
  installerStatusSummary,
  documentTriggerIds,
  expertTriggers
) => {
  const validationObject = {};
  const evaluateConditionsConfig = {
    isOnlyHilfsbetrieb: isRegisteredInstallerOnlyHilfsbetrieb(installerStatusSummary),
    form: FORM_CONSTANTS.DEB,
    triggers: documentTriggerIds,
  };
  DEB_DOCUMENTS_FIELDS[installerStatusSummary.installerEntry][getTenantId()].forEach((section) => {
    if (
      shouldDebSecondPageSectionRender(section, documentTriggerIds, installerStatusSummary) &&
      (section.whenShouldFieldRender
        ? evaluateCondition(section.whenShouldFieldRender, evaluateConditionsConfig)
        : true)
    ) {
      validationObject[section.name] = Yup.array().when([], {
        is: () => evaluateCondition(section.isOptional, evaluateConditionsConfig),
        then: Yup.array(),
        otherwise: Yup.array().min(1).required(VALIDATION_CONSTANTS.MANDATORY),
      });

      initialValues[section.name] = [];
    }
  });

  Object.keys(expertTriggers).forEach((key) => {
    if (!expertTriggers[key]) {
      return;
    }
    let expertValidation = {};
    initialValues[key] = {};

    const expert = valuesFirstPage.experts?.find(
      (expertFirstPage) => String(expertFirstPage.id) === String(key)
    );
    if (!expert) {
      return;
    }

    DEB_EXPERTS_DOCUMENTS_FIELDS[installerStatusSummary.installerEntry][getTenantId()].forEach(
      (section) => {
        if (
          shouldDebSecondPageSectionRender(
            section,
            expertTriggers[key],
            installerStatusSummary,
            expert
          )
        ) {
          expertValidation = {
            ...expertValidation,
            [section.name]: Yup.array().when([], {
              is: () => evaluateCondition(section.isOptional, evaluateConditionsConfig),
              then: Yup.array(),
              otherwise: Yup.array().min(1).required(VALIDATION_CONSTANTS.MANDATORY),
            }),
          };
          initialValues[key][section.name] = [];
        }
      }
    );

    validationObject[key] = Yup.object()
      .shape(expertValidation)
      .required(VALIDATION_CONSTANTS.REQUIRED);
  });

  const validationSchema = Yup.object().shape({
    changes: Yup.string()
      .trim()
      .nullable()
      .typeError('must be a string')
      .transform((value) => (value === '' ? null : value))
      .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(FORM_CONSTANTS.FREETEXT_INPUT, VALIDATION_CONSTANTS.TOO_LONG),
    isAddressPublic: Yup.bool().required(),
    canSendMail: Yup.bool().required(),
    ...validationObject,
  });

  return validationSchema;
};
export const doesExpertHaveMainBranch = (expert, installerStatusSummary) => {
  return (
    (expert.isExpertGasActive && isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.GAS)) ||
    (expert.isExpertEnergyActive &&
      isRegisteredBranchMain(installerStatusSummary, BRANCH_TYPE.ENERGY))
  );
};
export const getDEExpertPopupErrorMessage = (formik) => {
  if (
    formik.values.statusEnergy === EIV_STATUS.INACTIVE &&
    formik.values.statusGas === EIV_STATUS.INACTIVE
  ) {
    return 'Bitte wählen Sie eine Sparte';
  }

  if (!formik.values.isExpertEnergyActive && !formik.values.isExpertGasActive) {
    return 'Bitte wählen Sie eine Sparte';
  }

  if (!formik.isValid) {
    return 'Füllen Sie das Formular vollständig aus';
  }
  return '';
};

export const getDEExpertPopupDeleteErrorMessage = (formik) => {
  if (!formik.values.deleteEnergy && !formik.values.deleteGas) {
    return 'Bitte wählen Sie eine Sparte';
  }

  if (!formik.isValid) {
    return 'Füllen Sie das Formular vollständig aus';
  }
  return '';
};
